import { Grid, Tab, Tabs, styled } from "@mui/material";
import React, { useEffect } from "react";
import {
  getPortfolioInvestmentForm,
  getPortfolioTradeAvgForm,
} from "store/slices/portfolio/portfolioSlice";

import { PORTFOLIO_TYPES } from "../constants";
import useDispatch from "hooks/useDispatch";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function PortfolioTypeTabs() {
  const dispatch = useDispatch();
  const portfolioForm = useSelector(
    (state) => state.portfolio.portfolioForm?.data
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const portfolioType = +searchParams.get("portfolioType") || 0;
  const walletType = +searchParams.get("walletType") || 0;

  const handleGetFormValue = (type) => {
    if (type === PORTFOLIO_TYPES.trade.key) {
      dispatch(getPortfolioTradeAvgForm());
    } else {
      dispatch(getPortfolioInvestmentForm());
    }
  };

  const handleChangeChartType = (_, newValue) => {
    handleGetFormValue(newValue);

    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      portfolioType: newValue,
    });
  };

  const handleChangeWalletType = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      walletType: newValue,
    });
  };

  useEffect(() => {
    handleGetFormValue(portfolioType);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container mt={2}>
      <Grid item xs={12}>
        <TabsStyle value={portfolioType} onChange={handleChangeChartType}>
          {Object.values(PORTFOLIO_TYPES)?.map((type) => (
            <Tab label={type.name} value={type.key} />
          ))}
        </TabsStyle>
      </Grid>

      {portfolioForm?.lisWalletType && (
        <Grid item xs={12} mt={2}>
          <WalletTypeTabs value={walletType} onChange={handleChangeWalletType}>
            {portfolioForm?.lisWalletType?.map((type) => (
              <Tab label={type.name} value={type.key} />
            ))}
          </WalletTypeTabs>
        </Grid>
      )}
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    maxWidth: "300px",
    margin: "auto",
    justifyContent: "space-between",
  },
}));

const WalletTypeTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  [theme.breakpoints.down("md")]: {
    ".MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
}));

export default PortfolioTypeTabs;
